import { render } from "./my-permission.vue?vue&type=template&id=21d13dd0"
import script from "./my-permission.vue?vue&type=script&lang=js"
export * from "./my-permission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__